// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrder } from '@evolvemep/api-ts';
import { useDisclosure } from '@mantine/hooks';

import { GridMenu } from 'components/Mantine/GridMenu';
import { AddToShipmentFromWorkOrderModal } from 'modules/Shop/WorkOrders/WorkOrderDetail/Items/AddToShipmentFromWorkOrderModal';

type Props = {
  workOrder: WorkOrder;
  hasWorkOrderItems: boolean;
  onItemsAdded: () => void;
  allItemsInShippingOrder?: boolean;
};

/**
 * Three-dot menu on the WO Items section header that opens the push-flow Add To Shipment modal,
 * pre-selecting all eligible items (those with remaining unallocated quantity).
 */
export const WorkOrderItemsSectionMenu = ({
  workOrder,
  hasWorkOrderItems,
  onItemsAdded,
  allItemsInShippingOrder,
}: Props) => {
  const [opened, { open, close }] = useDisclosure();
  return (
    <>
      <GridMenu
        variant="light"
        // `Remove all items` will be a future option here; leave it out for now.
        options={[{ value: 'Add items to shipping order', disabled: !hasWorkOrderItems }]}
        onMenuItemSelected={open}
      />
      <AddToShipmentFromWorkOrderModal
        workOrder={workOrder}
        initialValues={{
          items: [],
          // If all items are in the shipping order, don't pre-select the work order.
          allSelectedWorkOrderIds: allItemsInShippingOrder ? [] : [workOrder.workOrderId],
        }}
        opened={opened}
        onClose={close}
        onItemsAdded={onItemsAdded}
      />
    </>
  );
};
